import React, { Component } from 'react';
import Loader from '../components/Loader';
import Logo from '../components/Logo';

class Auth extends Component {
  componentDidMount = () => {
    const hasLoginStarted = sessionStorage.getItem('hasLoginStarted');
    if (hasLoginStarted) {
      setTimeout(() => {
        this.props.signIn();
      }, 5000);
    } else {
      sessionStorage.setItem('hasLoginStarted', true);
      this.props.signIn();
    }
  };

  render() {
    const { hash } = new URL(window.location.href);
    return (
      <div className='h-90vh d-flex align-items-center justify-content-center'>
        <div className='text-center'>
          <Logo />
          <p className='text-primary'>
            {hash ? 'Fetching Details...' : 'Loading...'}
          </p>
          <Loader opacity={0.4} color='black' />
        </div>
      </div>
    );
  }
}

export default Auth;
